define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader'], function ($, transit, modernizr, container, preloader) {

    var slider = function (id) {

        var publicVars = {
            intervalTime: 7000 /* time to automatically slide */,
        };

        var privateVars = {
            name: 'slider(' + id + ')',
            change: 0, /* change image flag */
            itemsCount: 0, /* number of slider items */
            currentItem: 1, /* current slider item */
            interval: '', /* interval handler */
            sliderItemsMap: {},
            imagesSrcMap: {} /* image src map */,
            allowedCustomAnims: ['transform', 'slide', 'fade'] /* custom anims table */,
            arrowClickedHelper: '' /* info which arrow was clicked if any */,
            pageClickedHelper: '' /* info if slider page was clicked if so */,
            preloadedAll: false,

            touchStart: 0,
            touchDiff: 0,
            touchStartY: 0,
            touchDiffY: 0,

            slideStarted: false,
            endTrans: false,

            callbacks: {
                beforeSlideChange: null,
                afterSlideChange: null
            }

        };


        var privateMethods = {
            prepareObj: function (options) {

                publicVars = container.performCopy(publicVars, options);

                preloader.init();

                privateMethods.bind();

                privateMethods.startup();

                privateMethods.preloadImages();

            },
            /*
             * preload images
             */
            preloadImages: function () {
                var currentFirst = parseInt(privateVars.currentItem);
                var currentLast = currentFirst;

                for (var i = 0; i < 3; i++) {

                    if (currentFirst > 1) {
                        currentFirst = currentFirst - 1;
                    } else {
                        currentFirst = privateVars.itemsCount;
                    }

                    if(currentLast == privateVars.itemsCount) {
                        currentLast = 1;
                    } else {
                        currentLast = currentLast + 1;
                    }

                    if (privateVars.sliderItemsMap[(currentLast - 1)]) {

                        var imgSrc = container.getData(privateVars.sliderItemsMap[(currentLast - 1)].element[0], 'img.src');
                        var id = container.getData(privateVars.sliderItemsMap[(currentLast - 1)].element[0], 'id');

                        if(publicVars.cssId.sliderItemBoxImgCls) {
                            $(publicVars.cssId.sliderItemBoxImgCls, publicVars.cssId.sliderItem + id).attr('src', imgSrc);
                        }

                        preloader.preloadSingleImage(privateVars.name, imgSrc, function() {
                        });

                    }


                    if (privateVars.sliderItemsMap[(currentFirst - 1)]) {

                        var imgSrc = container.getData(privateVars.sliderItemsMap[(currentFirst - 1)].element[0], 'img.src');
                        var id = container.getData(privateVars.sliderItemsMap[(currentFirst - 1)].element[0], 'id');

                        if(publicVars.cssId.sliderItemBoxImgCls) {
                            $(publicVars.cssId.sliderItemBoxImgCls, publicVars.cssId.sliderItem + id).attr('src', imgSrc);
                        }

                        preloader.preloadSingleImage(privateVars.name, imgSrc, function() {
                        });

                    }

                }
            },

            startup: function () {
                privateVars.itemsCount = parseInt($(publicVars.cssId.sliderId + ' ' + publicVars.cssId.sliderItem).length);

                if (publicVars.currentItem) {
                    privateVars.currentItem = parseInt(publicVars.currentItem);
                }

                container.msg(privateVars.name + ' - items count ' + privateVars.itemsCount);

                $(publicVars.cssId.sliderItem).each(function(key, value) {

                    var imgSrc = container.getData($(this)[0], 'img.src');

                    privateVars.imagesSrcMap[(key + 1)] = imgSrc;

                    var cloned = $(this).clone(true, true);

                    if(publicVars.options && publicVars.options.stripHref == 1) {
                        cloned.removeAttr('href');
                    }

                    //cloned.removeClass(publicVars.cssId.sliderActiveCls.substr(1));

                    privateVars.sliderItemsMap[key] = {
                        element: cloned
                    };

                    // if (publicVars.perSetItems < (key + 1)) {
                    //     $(this).remove();
                    // }

                });

                if (privateVars.itemsCount > 1) {
                    privateMethods.autoSlide();
                } else {
                    if (publicVars.cssId.sliderArrowInactive) {
                        $(publicVars.cssId.sliderArrowLeft).addClass(publicVars.cssId.sliderArrowInactive.substr(1));
                    }
                    if (publicVars.cssId.sliderArrowInactive) {
                        $(publicVars.cssId.sliderArrowRight).addClass(publicVars.cssId.sliderArrowInactive.substr(1));
                    }
                }
            },
            restart: function () {

                container.msg(privateVars.name + ' - restart');

                privateVars.change = 0;
                privateVars.itemsCount = 0;
                privateVars.currentItem = 1;

                privateMethods.preloadImages();

                clearInterval(privateVars.interval);

            },
            bind: function () {
                container.msg(privateVars.name + ' - module started');

                //gallery nav circle clicked
                if (publicVars.cssId.sliderPage) {
                    $(publicVars.cssId.sliderPage).click(function () {

                        var id = container.getData($(this)[0], 'page.id');

                        container.msg(privateVars.name + ' nav clicked id ' + id);

                        privateVars.pageClickedHelper = 1;

                        if (id != privateVars.currentItem && privateVars.change == 0) {
                            privateVars.change = 1;

                            privateMethods.changeSlide(id);
                        }
                    });
                }

                //gallery arrows click
                $(publicVars.cssId.sliderArrowLeft).click(function (e) {

                    if (privateVars.itemsCount > 1 && privateVars.change == 0) {

                        privateVars.change = 1;

                        container.msg(privateVars.name + ' - main left arrow clicked');

                        privateVars.arrowClickedHelper = 'left';

                        var id = (privateVars.currentItem > 1) ? (parseInt(privateVars.currentItem) - 1) : privateVars.itemsCount;

                        privateMethods.changeSlide(id);
                    }

                });

                //gallery arrow click
                $(publicVars.cssId.sliderArrowRight).click(function (e) {

                    if (privateVars.itemsCount > 1 && privateVars.change == 0) {

                        privateVars.change = 1;

                        container.msg(privateVars.name + ' - main right arrow clicked');

                        privateVars.arrowClickedHelper = 'right';

                        var id = (privateVars.currentItem < privateVars.itemsCount) ? (parseInt(privateVars.currentItem) + 1) : 1;

                        privateMethods.changeSlide(id);
                    }


                });

                /*$(publicVars.cssId.sliderId).mousedown(function(e) {
                 e.preventDefault();
                 return privateMethods.slideMouseDown(e);
                 });*/

                $(publicVars.cssId.sliderId).bind('touchstart', function (e) {
                    //e.preventDefault();
                    if (privateVars.itemsCount > 1) {
                        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                        return privateMethods.slideMouseDown(touch);
                    }
                });

                /*$(publicVars.cssId.sliderId).mousemove(function(e) {
                 e.preventDefault();
                 return privateMethods.slideMouseMove(e);
                 });*/

                $(publicVars.cssId.sliderId).bind('touchmove', function (e) {
                    //e.preventDefault();
                    if (privateVars.itemsCount > 1) {
                        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                        return privateMethods.slideMouseMove(touch, e);
                    }
                });

                /*$(publicVars.cssId.sliderId).mouseup(function(e) {
                 e.preventDefault();
                 return privateMethods.slideMouseUp(e);
                 });*/

                $(publicVars.cssId.sliderId).bind('touchend', function (e) {
                    //e.preventDefault();
                    if (privateVars.itemsCount > 1) {
                        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                        return privateMethods.slideMouseUp(touch);
                    }
                });


            },

            setCallback: function (type, callback) {
                privateVars.callbacks[type] = callback;
            },

            slideMouseDown: function (e) {

                if (!privateVars.slideStarted && privateVars.change == 0) {
                    privateVars.touchStart = e.pageX;
                    privateVars.touchStartY = e.pageY;

                    privateVars.slideStarted = true;

                    clearInterval(privateVars.interval);
                }

                //return false;

            },

            slideMouseMove: function (e, ev) {

                if (privateVars.slideStarted && !privateVars.endTrans && privateVars.change == 0) {

                    var moveFactor = -($('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).width());

                    privateVars.touchDiff = privateVars.touchStart - e.pageX;
                    privateVars.touchDiffY = privateVars.touchStartY - e.pageY;

                    if (privateVars.touchDiff < 0) {
                        var nextId = (privateVars.currentItem > 1) ? (parseInt(privateVars.currentItem) - 1) : privateVars.itemsCount;
                        $('#' + publicVars.cssId.sliderItem.substr(1) + nextId).css({
                            left: (moveFactor - privateVars.touchDiff) + 'px',
                            display: 'block'
                        });
                    } else if (privateVars.touchDiff > 0) {
                        var nextId = (privateVars.currentItem < privateVars.itemsCount) ? parseInt(privateVars.currentItem) + 1 : 1;
                        $('#' + publicVars.cssId.sliderItem.substr(1) + nextId).css({
                            left: (-(moveFactor) - privateVars.touchDiff) + 'px',
                            display: 'block'
                        });
                    }

                    $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).css({left: -(privateVars.touchDiff) + 'px'});

                    if (Math.abs(privateVars.touchDiff) >= Math.abs(privateVars.touchDiffY)) {
                        ev.preventDefault();
                    }

                }

                //return false;
            },

            slideMouseUp: function (e) {

                if (privateVars.slideStarted && privateVars.change == 0) {
                    privateVars.endTrans = true;
                    if (privateVars.touchDiff < -40) {
                        var nextId = (privateVars.currentItem > 1) ? (parseInt(privateVars.currentItem) - 1) : privateVars.itemsCount;
                        privateVars.change = 1;
                        privateVars.arrowClickedHelper = 'left';
                        //privateMethods.fireCustomAnim(2, 'slide');
                        privateMethods.changeSlide(nextId);
                    } else if (privateVars.touchDiff > 40) {
                        var nextId = (privateVars.currentItem < privateVars.itemsCount) ? parseInt(privateVars.currentItem) + 1 : 1;
                        privateVars.change = 1;
                        privateVars.arrowClickedHelper = 'right';
                        //privateMethods.fireCustomAnim(2, 'slide'); 
                        privateMethods.changeSlide(nextId);
                    } else {

                        $(publicVars.cssId.sliderItem).css({display: 'none', left: '0px'});
                        $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).css({
                            left: '0px',
                            display: 'block'
                        });

                        privateVars.slideStarted = false;
                        privateVars.endTrans = false;

                        privateVars.touchDiff = 0;
                        privateVars.touchStart = 0;
                        privateVars.touchDiffY = 0;
                        privateVars.touchStartY = 0;
                    }
                }
            },

            /*
             * TO BE REFACTORED
             * set arrows classes into active or inactive state
             */
            setInactiveClasses: function () {

                //gallery arrows
                if (privateVars.currentItem > 1) {
                    $('#' + publicVars.cssId.galleryMainArrowLeft).addClass(publicVars.cssId.generalArrowLeftActive);
                } else {
                    $('#' + publicVars.cssId.galleryMainArrowLeft).removeClass(publicVars.cssId.generalArrowLeftActive);
                }

                //gallery arrows
                if (privateVars.currentItem < privateVars.itemsCount) {
                    $('#' + publicVars.cssId.galleryMainArrowRight).addClass(publicVars.cssId.generalArrowRightActive);
                } else {
                    $('#' + publicVars.cssId.galleryMainArrowRight).removeClass(publicVars.cssId.generalArrowRightActive);
                }
            },

            setCurrentItem: function (itemId) {
                privateVars.currentItem = parseInt(itemId);
                privateMethods.preloadImages();
            },

            /*
             * set autoslide interval
             */
            autoSlide: function () {
                if (publicVars.autoSlide) {
                    privateVars.interval = setInterval(function () {
                        container.msg(privateVars.name + ' - set interval');

                        var nextId = (privateVars.currentItem < privateVars.itemsCount) ? parseInt(privateVars.currentItem) + 1 : 1;

                        privateVars.change = 1;

                        privateMethods.changeSlide(nextId);

                    }, publicVars.intervalTime);
                }
            },
            /*
             * change gallery slide
             * 
             * @param Int id (id of next slide element)
             */
            changeSlide: function (id) {

                container.msg(privateVars.name + ' - change ' + id);

                if (typeof privateVars.callbacks.beforeSlideChange === 'function') {
                    privateVars.callbacks.beforeSlideChange({
                        oldId: parseInt(privateVars.currentItem),
                        newId: parseInt(id)
                    });
                }

                clearInterval(privateVars.interval);

                var customAnim = false;

                if (privateVars.pageClickedHelper == 1 && typeof publicVars.pageAnim !== 'undefined' && publicVars.pageAnim !== '') {
                    container.msg(privateVars.name + ' - requested custom page anim ' + publicVars.pageAnim);

                    if (Modernizr.csstransitions && $.inArray(publicVars.pageAnim, privateVars.allowedCustomAnims) > -1) {
                        customAnim = publicVars.pageAnim;
                    }

                } else if (privateVars.arrowClickedHelper != '' && typeof publicVars.pageAnim !== 'undefined' && publicVars.arrowsAnim !== '') {
                    container.msg(privateVars.name + ' - requested custom page anim ' + publicVars.arrowsAnim);

                    if (Modernizr.csstransitions && $.inArray(publicVars.arrowsAnim, privateVars.allowedCustomAnims) > -1) {
                        customAnim = publicVars.arrowsAnim;
                    }

                } else if (typeof publicVars.anim !== 'undefined' && publicVars.anim !== '') {
                    container.msg(privateVars.name + '- requested custom anim ' + publicVars.anim);

                    if (Modernizr.csstransitions && $.inArray(publicVars.anim, privateVars.allowedCustomAnims) > -1) {
                        customAnim = publicVars.anim;
                    }
                }

                if (publicVars.cssId.sliderPage) {
                    $('#' + publicVars.cssId.sliderPage.substr(1) + privateVars.currentItem).removeClass(publicVars.cssId.sliderPageActive.substr(1));
                    $('#' + publicVars.cssId.sliderPage.substr(1) + id).addClass(publicVars.cssId.sliderPageActive.substr(1));
                }

                if (publicVars.cssId.sliderLabelCount) {
                    $(publicVars.cssId.sliderLabelCount).html(id);
                }

                if (customAnim) {
                    container.msg(privateVars.name + ' - request accepted: ' + publicVars.anim);

                    privateMethods.fireCustomAnim(id, customAnim);

                } else {
                    $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).transit({
                        opacity: 0,
                        scale: '0.5'
                    }, 500, function () {
                        $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).removeAttr('style');
                        $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).css({display: 'none'});
                    });

                    var imgSrc = container.getData($('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem)[0], 'img.src');

                    if (!preloader.isPreloadedPath(privateVars.name, imgSrc)) {
                        $(publicVars.cssId.sliderAjaxLoader).fadeIn(100);
                    }

                    preloader.preloadSingleImage(privateVars.name, imgSrc, function () {

                        $(publicVars.cssId.sliderAjaxLoader).stop(true, true).fadeOut(100);
                        $('#' + publicVars.cssId.sliderItem.substr(1) + id).css({
                            opacity: 0,
                            scale: '0.5',
                            display: 'block'
                        });

                        $('#' + publicVars.cssId.sliderItem.substr(1) + id).transit({
                            opacity: 1,
                            scale: '1'
                        }, 800, function () {

                            //$('#' + publicVars.cssId.sliderItem.substr(1) + id).removeAttr('style');
                            //$('#' + publicVars.cssId.sliderItem.substr(1) + id).css({display: 'block'});

                            privateMethods.afterSlideAnimConfig(id);
                        });
                    });
                }

            },
            /*
             * after slide change settings
             * 
             * @param id Int (id of next slide)
             */
            afterSlideAnimConfig: function (id) {

                if (typeof privateVars.callbacks.afterSlideChange === 'function') {
                    privateVars.callbacks.afterSlideChange({
                        oldId: parseInt(privateVars.currentItem),
                        newId: parseInt(id)
                    });
                }

                privateVars.currentItem = parseInt(id);
                privateMethods.preloadImages();
                privateVars.change = 0;

                privateVars.touchDiff = 0;
                privateVars.touchStart = 0;
                privateVars.touchDiffY = 0;
                privateVars.touchStartY = 0;

                privateVars.arrowClickedHelper = '';
                privateVars.pageClickedHelper = '';

                privateVars.slideStarted = false;
                privateVars.endTrans = false;

                //privateMethods.setInactiveClasses();

                privateMethods.autoSlide();
            },
            /*
             * switch for custom slide anims
             * 
             * @param id Int (id of next slide)
             */
            fireCustomAnim: function (id, anim) {

                if (anim == 'transform') {
                    privateMethods.fireTransformAnim(id);
                } else if (anim == 'slide') {
                    privateMethods.fireSlideAnim(id);
                } else if (anim == 'fade') {
                    privateMethods.fireFadeAnim(id);
                }

                /*else if (publicVars.anim == 'square') {
                 privateMethods.fireSquareAnim(id);
                 }*/

            },
            /*
             * custom anim: slide
             * 
             * @param id Int (oid of next slide)
             */
            fireSlideAnim: function (id) {

                var moveFactor = -($('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).width());

                if (privateVars.arrowClickedHelper == 'left') {
                    moveFactor = -moveFactor;
                }

                if (privateVars.pageClickedHelper == 1) {
                    if (privateVars.currentItem > id) {
                        moveFactor = -moveFactor;
                    }
                }

                container.msg(privateVars.name + ' - animation move factor ' + moveFactor);

                var prevId = parseInt(privateVars.currentItem);
                /*$('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).transit({left: moveFactor + 'px'}, 500, function () {
                 $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).removeAttr('style');
                 $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).css({display: 'none', left: '0'});
                 });*/

                var imgSrc = container.getData($('#' + publicVars.cssId.sliderItem.substr(1) + id)[0], 'img.src');

                if (!preloader.isPreloadedPath(privateVars.name, imgSrc)) {
                    $(publicVars.cssId.sliderAjaxLoader).fadeIn(100);
                }

                preloader.preloadSingleImage(privateVars.name, imgSrc, function () {

                    $(publicVars.cssId.sliderAjaxLoader).stop(true, true).fadeOut(100);

                    $('#' + publicVars.cssId.sliderItem.substr(1) + id).css({
                        left: (-(moveFactor) - privateVars.touchDiff) + 'px',
                        display: 'block'
                    });

                    $('#' + publicVars.cssId.sliderItem.substr(1) + id).transit({left: 0}, 500, function () {

                        $('#' + publicVars.cssId.sliderItem.substr(1) + id).removeAttr('style');
                        $('#' + publicVars.cssId.sliderItem.substr(1) + id).css({display: 'block'});

                        privateMethods.afterSlideAnimConfig(id);
                    });

                    $('#' + publicVars.cssId.sliderItem.substr(1) + prevId).transit({left: (moveFactor) + 'px'}, 500, function () {
                        $('#' + publicVars.cssId.sliderItem.substr(1) + prevId).removeAttr('style');
                        $('#' + publicVars.cssId.sliderItem.substr(1) + prevId).css({display: 'none', left: '0'});
                    });
                });
            },
            /*
             * custom anim: fade
             * 
             * @param id Int (oid of next slide)
             */
            fireFadeAnim: function (id) {

                $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).fadeOut(500, function () {
                    $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).removeAttr('style');
                    $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).css({display: 'none'});
                });

                var imgSrc = container.getData($('#' + publicVars.cssId.sliderItem.substr(1) + id)[0], 'img.src');

                if (!preloader.isPreloadedPath(privateVars.name, imgSrc)) {
                    $(publicVars.cssId.sliderAjaxLoader).fadeIn(100);
                }

                preloader.preloadSingleImage(privateVars.name, imgSrc, function () {

                    $(publicVars.cssId.sliderAjaxLoader).stop(true, true).fadeOut(100);

                    $('#' + publicVars.cssId.sliderItem.substr(1) + id).fadeIn(500, function () {

                        $('#' + publicVars.cssId.sliderItem.substr(1) + id).removeAttr('style');
                        $('#' + publicVars.cssId.sliderItem.substr(1) + id).css({display: 'block'});

                        privateMethods.afterSlideAnimConfig(id);
                    });
                });
            },
            /*
             * custom anim: transform
             * 
             * @param id Int (oid of next slide)
             */
            fireTransformAnim: function (id) {
                $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).transit({
                    opacity: 0,
                    transform: 'scale(0, 1)'
                }, 500, function () {
                    $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).removeAttr('style');
                    $('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).css({display: 'none'});
                });

                var imgSrc = container.getData($('#' + publicVars.cssId.sliderItem.substr(1) + id)[0], 'img.src');

                if (!preloader.isPreloadedPath(privateVars.name, imgSrc)) {
                    $(publicVars.cssId.sliderAjaxLoader).fadeIn(100);
                }

                preloader.preloadSingleImage(privateVars.name, imgSrc, function () {

                    $(publicVars.cssId.sliderAjaxLoader).stop(true, true).fadeOut(100);

                    $('#' + publicVars.cssId.sliderItem.substr(1) + id).css({
                        opacity: 0,
                        transform: 'scale(0, 1)',
                        display: 'block'
                    });

                    $('#' + publicVars.cssId.sliderItem.substr(1) + id).transit({
                        opacity: 1,
                        transform: 'scale(1)'
                    }, 800, function () {

                        $('#' + publicVars.cssId.sliderItem.substr(1) + id).removeAttr('style');
                        $('#' + publicVars.cssId.sliderItem.substr(1) + id).css({display: 'block'});

                        privateMethods.afterSlideAnimConfig(id);
                    });
                });

            },

            changeSlideLeft: function () {
                if (privateVars.itemsCount > 1 && privateVars.change == 0) {

                    privateVars.change = 1;

                    container.msg(privateVars.name + ' - main left arrow clicked');

                    privateVars.arrowClickedHelper = 'left';

                    var id = (privateVars.currentItem > 1) ? (parseInt(privateVars.currentItem) - 1) : privateVars.itemsCount;

                    privateMethods.changeSlide(id);
                }
            },

            changeSlideRight: function () {
                if (privateVars.itemsCount > 1 && privateVars.change == 0) {

                    privateVars.change = 1;

                    container.msg(privateVars.name + ' - main right arrow clicked');

                    privateVars.arrowClickedHelper = 'right';

                    var id = (privateVars.currentItem < privateVars.itemsCount) ? (parseInt(privateVars.currentItem) + 1) : 1;

                    privateMethods.changeSlide(id);
                }
            }

            /*
             * REQUIRE REFACTOR
             * custom anim: square
             * 
             * @param id Int (oid of next slide)
             
             fireSquareAnim: function (id) {
             
             var animDiv = $('<div></div>');
             animDiv.attr('id', 'jsCustomSliderCreatedAnimContainer' + id);
             
             var backgroundStyle = 'url(' + privateVars.imagesSrcMap[privateVars.currentItem] + ') no-repeat';
             var backgroundStyleNew = 'url(' + privateVars.imagesSrcMap[id] + ') no-repeat';
             
             var containerWidth = $('#' + publicVars.cssId.sliderImages).outerWidth();
             var containerHeight = $('#' + publicVars.cssId.sliderImages).outerHeight();
             
             var divChild1 = $('<div id="jsCustomSliderCreatedAnimElement1"></div>');
             var divChild2 = $('<div id="jsCustomSliderCreatedAnimElement2"></div>');
             var divChild3 = $('<div id="jsCustomSliderCreatedAnimElement3"></div>');
             var divChild4 = $('<div id="jsCustomSliderCreatedAnimElement4"></div>');
             
             var childPos1 = '0 0';
             var childPos2 = '-' + parseInt(containerWidth / 2) + 'px 0';
             var childPos3 = '0 -' + parseInt(containerHeight / 2) + 'px';
             var childPos4 = '-' + parseInt(containerWidth / 2) + 'px -' + parseInt(containerHeight / 2) + 'px';
             
             animDiv.css({background: backgroundStyleNew, display: 'block', width: containerWidth, height: containerHeight, overflow: 'hidden'});
             
             divChild1.css({background: backgroundStyle, backgroundPosition: childPos1, width: parseInt(containerWidth / 2) + 'px',
             height: parseInt(containerHeight / 2) + 'px', position: 'absolute', 'top': 0, 'left': 0, display: 'block'});
             
             divChild2.css({background: backgroundStyle, backgroundPosition: childPos2, width: parseInt(containerWidth / 2) + 'px',
             height: parseInt(containerHeight / 2) + 'px', position: 'absolute', 'top': 0, 'left': parseInt(containerWidth / 2) + 'px', display: 'block'});
             
             divChild3.css({background: backgroundStyle, backgroundPosition: childPos3, width: parseInt(containerWidth / 2) + 'px',
             height: parseInt(containerHeight / 2) + 'px', position: 'absolute', 'top': parseInt(containerHeight / 2) + 'px', 'left': 0, display: 'block'});
             
             divChild4.css({background: backgroundStyle, backgroundPosition: childPos4, width: parseInt(containerWidth / 2) + 'px',
             height: parseInt(containerHeight / 2) + 'px', position: 'absolute', 'top': parseInt(containerHeight / 2) + 'px', 'left': parseInt(containerWidth / 2) + 'px', display: 'block'});
             
             animDiv.append(divChild1);
             animDiv.append(divChild2);
             animDiv.append(divChild3);
             animDiv.append(divChild4);
             
             $('#' + publicVars.cssId.sliderImages).prepend(animDiv);
             $('#' + publicVars.cssId.sliderImages + ' img').remove();
             
             $('#jsCustomSliderCreatedAnimContainer' + privateVars.currentItem).remove();
             
             $('#jsCustomSliderCreatedAnimElement1').transit({top: '-' + parseInt(containerHeight / 2) +
             'px', left: '-' + parseInt(containerWidth / 2) + 'px', opacity: '0', boxShadow: '0 0 100px 100px white'}, 1200);
             $('#jsCustomSliderCreatedAnimElement2').transit({top: '-' + parseInt(containerHeight / 2) +
             'px', left: '' + parseInt(containerWidth) + 'px', opacity: '0', boxShadow: '0 0 100px 100px white'}, 1200);
             $('#jsCustomSliderCreatedAnimElement3').transit({top: '' + parseInt(containerHeight) +
             'px', left: '-' + parseInt(containerWidth / 2) + 'px', opacity: '0', boxShadow: '0 0 100px 100px white'}, 1200);
             $('#jsCustomSliderCreatedAnimElement4').transit({top: '' + parseInt(containerHeight) +
             'px', left: '' + parseInt(containerWidth) + 'px', opacity: '0', boxShadow: '0 0 100px 100px white'}, 1200, function () {
             privateMethods.afterSlideAnimConfig(id);
             });
             }
             */

        };

        var publicObj = {
            init: function (options) {
                privateMethods.prepareObj(options);
            },
            restart: function () {
                privateMethods.restart();
            },
            preloadImages: function () {
                privateMethods.preloadImages();
            },
            setCallback: function (type, callback) {
                privateMethods.setCallback(type, callback);
            },
            setCurrentItem: function (itemId) {
                privateMethods.setCurrentItem(itemId);
            },
            getCurrentItem: function () {
                return privateVars.currentItem;
            },
            changeSlideLeft: function () {
                privateMethods.changeSlideLeft();
            },
            changeSlideRight: function () {
                privateMethods.changeSlideRight();
            }
        }


        return publicObj;
    };

    var factory = {
        objId: 0,
        /**
         * Get new preloader object
         *
         * @returns preloader
         */
        create: function () {
            factory.objId++;

            var obj = slider(factory.objId);

            return obj;
        }
    };

    return {
        create: factory.create
    }

});

/*
 ---
 var slider = sliderFactory.create();
 ---
 sliderSetup: {
 cssId: {
 sliderId: "#slider",
 sliderItem: ".slider-item",
 sliderPage: ".slider-page",
 sliderPageActive: ".is-active"
 }
 }
 ---
 <section class="slider site-wide" id="slider">
 
 <div class="slider-item slider-item1" id="slider-item1" data-img.src="<?php print base_path() . drupal_get_path('theme', 'avengers') . '/assets/img/homepage/slider/slide1.png'; ?>" style="display: block;">
 
 </div>
 <div class="slider-item slider-item2" id="slider-item2" data-img.src="<?php print base_path() . drupal_get_path('theme', 'avengers') . '/assets/img/homepage/slider/slide2.png'; ?>" style="display: none;">
 
 </div>
 <div class="slider-item slider-item3" id="slider-item3" data-img.src="<?php print base_path() . drupal_get_path('theme', 'avengers') . '/assets/img/homepage/slider/slide3.png'; ?>" style="display: none;">
 
 </div>
 
 <div class="slider-bar">
 
 <div class="slider-page slider-page1 is-active" id="slider-page1" data-page.id = "1"></div>
 <div class="slider-page slider-page2" id="slider-page2" data-page.id = "2"></div>
 <div class="slider-page slider-page3" id="slider-page3" data-page.id = "3"></div>
 
 </div>
 </section>
 ----
 advanced setup:
 
 sliderSetup: {
 cssId: {
 sliderId: "#gallery",
 sliderItem: ".gallery-item",
 sliderPage: ".gallery-page",
 sliderPageActive: ".is-active",
 sliderAjaxLoader: "#gallery-ajax-loader",
 sliderArrowLeft: "#gallery-arrow-area-left",
 sliderArrowRight: "#gallery-arrow-area-right",
 sliderArrowInactive: ".gallery-arrow-inactive"
 sliderLabelCount: "#gallery-slider-label-count",
 },
 
 anim: "slide", //default anim
 pageAnim: "slide", //anim when slider page is clicked
 arrowsAnim: "slide" //anim when arrow is clicked
 }
 
 <div class="gallery-slider-label gallery1-slider-label"><span class="gallery-slider-label-count" id="gallery-slider-label-count">1</span> / 3</div>
 
 */